import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../app/app.store';
import { selectAuth } from '../app/features/auth/auth.slice';
import { resetOnboardingState } from '../app/features/onboarding/onboarding.slice';

export default function useAuth() {
  const dispatch = useAppDispatch();
  const auth = useAppSelector(selectAuth);
  const {
    profileInfo,
    userInfo,
    verifiedInfo,
    modulesInfo,
    permissionsInfo,
    ...rest
  } = auth || {};

  const clearOnboardInfo = useCallback(() => {
    dispatch(resetOnboardingState());
    localStorage.removeItem('register-step');
  }, [dispatch]);

  return {
    ...rest,
    profileInfo,
    modulesInfo,
    permissionsInfo,
    verifiedInfo,
    clearOnboardInfo,
    tenantId: String(profileInfo?.tenant_id),
    organizationId: String(profileInfo?.organization_id),
  };
}
